export default "__VITE_ASSET__2QeHTtWN__"